import { render, staticRenderFns } from "./collectionCreate.vue?vue&type=template&id=204cb529&scoped=true"
import script from "./collectionCreate.vue?vue&type=script&lang=js"
export * from "./collectionCreate.vue?vue&type=script&lang=js"
import style0 from "./collectionCreate.vue?vue&type=style&index=0&id=204cb529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204cb529",
  null
  
)

export default component.exports